var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comboDialog"},[_c('el-dialog',{attrs:{"title":"选择可导出项","width":"82%","visible":_vm.visible},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('rtas-choose',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === '1'),expression:"type === '1'"}]})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c8f7b4c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/exportData/comboDialog.vue
// module id = null
// module chunks = 